export default __webpack_public_path__ + "24f80c4d579d41e298ee439dffd6ed79.png";